import View from '../View';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {
  TListOfElement,
  TText,
  TRecord,
  TBoolean,
} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  displayName: 'Cart Line Item',
  showEmpty: true,
  constraints: {
    ancestors: [{is: 'CommerceCartForm', rule: 'ExactlyOne'}],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'flex',
          marginBottom: px(16),
          justifyContent: 'space-between',
          alignItems: 'baseline',
          flexGrow: 0,
          flexShrink: 0,
          flexBasis: 'auto',
        },
      },
    },
  },
  render: View,
  fields: {
    children: TListOfElement,
    attr: TRecord({'aria-live': TText, 'aria-atomic': TBoolean}),
  },
});

export default config;
